<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="90%"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-row>
      <el-form
        ref="form"
        :model="customerSingle"
        :rules="rules"
        :inline="true"
        label-position="right"
        label-width="160px"
      >
        <el-row>
          <el-col :span="24" style="margin: 20px 0">
            <el-alert
              title="注意事项"
              type="warning"
              description="请创建人仔细填写档案库信息，并定期更新，保证信息的正确性"
              show-icon
            >
            </el-alert>
          </el-col>
        </el-row>
        <el-form-item label="客户ID:" prop="AdvertiserID">
          <el-input
            v-model="customerSingle.AdvertiserID"
            disabled
            placeholder="请输入客户ID"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户名称:" prop="Name">
          <el-input
            v-model="customerSingle.Name"
            disabled
            placeholder="请输入客户名称"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="注册时间:" prop="RegisterTime">
          <el-col>
            <el-date-picker
              type="date"
              placeholder="请选择注册时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="customerSingle.RegisterTime"
              disabled
              style="width: 202px"
            ></el-date-picker>
          </el-col>
        </el-form-item> -->
        <el-form-item label="账户ID:" prop="AccountID">
          <el-input
            v-model="customerSingle.AccountID"
            disabled
            placeholder="请输入账户ID"
          ></el-input>
        </el-form-item>
        <el-form-item label="账户名称:" prop="AccountName">
          <el-input
            v-model="customerSingle.AccountName"
            disabled
            placeholder="请输入账户名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="开户时间:" prop="CooperateTime">
          <el-col>
            <el-date-picker
              type="date"
              placeholder="请选择开始合作时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="customerSingle.CooperateTime"
              disabled
              style="width: 202px"
            ></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="账户首次消费日:" prop="FirstSpendTime">
          <el-col>
            <el-date-picker
              type="date"
              placeholder="请选择账户首次消费日"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="customerSingle.FirstSpendTime"
              disabled
              style="width: 202px"
            ></el-date-picker>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="公司行业类目:" prop="Industry">
          <el-cascader
            v-model="customerSingle.Industry"
            :options="industry"
            disabled
            :props="{ expandTrigger: 'hover' }"
            style="width: 202px"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="账户状态:" prop="Status">
          <el-input
            v-model="customerSingle.Status"
            disabled
            placeholder="请输入账户状态"
          ></el-input>
        </el-form-item>
        <el-form-item label="合规信用值:" prop="CreditScore">
          <el-input
            v-model="customerSingle.CreditScore"
            disabled
            placeholder="请输入合规信用值"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="SF对应二级账号:" prop="SFAccount">
          <el-input
            v-model="customerSingle.SFAccount"
            disabled
            placeholder="请输入SF对应二级账号"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="客户类型:" prop="Grade">
          <el-input
            v-model="customerSingle.Grade"
            disabled
            placeholder="客户类型"
          ></el-input>
          <el-select v-model="value" placeholder="请选择客户类型">
            <el-option
              v-for="item in Gradelist"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="上月消费日均:" prop="MonthlyBudget">
          <el-input
            v-model="customerSingle.MonthlyBudget"
            disabled
            placeholder="请输入上月消费日均"
          ></el-input>
        </el-form-item>
        <el-form-item label="中心:" prop="CenterName">
          <el-input v-model="customerSingle.CenterName" disabled></el-input>
        </el-form-item>
        <el-form-item label="部门:" prop="DeptsName">
          <el-input v-model="customerSingle.DeptsName" disabled></el-input>
        </el-form-item>
        <el-form-item label="优化师:" prop="UserName">
          <el-input v-model="customerSingle.UserName" disabled></el-input>
        </el-form-item>
        <el-form-item label="工号:" prop="UserId">
          <el-input v-model="customerSingle.UserId" disabled></el-input>
        </el-form-item>
        <el-form-item
          label=""
          label-width="120"
          style="font-size: 22px; font-weight: bold; color: #c00000"
        ></el-form-item>
        <el-row>
          <el-col :span="24">
            <h6 class="cus-title">客户公司基本信息：</h6>
          </el-col>
        </el-row>
        <el-form-item label="公司人员规模:" prop="Scale">
          <el-select
            v-model="customerSingle.Scale"
            placeholder="请选择"
            style="width: 202px"
          >
            <el-option
              :label="item"
              :value="item"
              v-for="(item, index) in Scale"
              :key="'open' + index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司是否上市:" prop="IsIPO">
          <el-switch
            v-model="customerSingle.IsIPO"
            style="width: 202px"
          ></el-switch>
        </el-form-item>
        <!-- <el-form-item label="公司性质:" prop="Nature">
          <el-input
            v-model="customerSingle.Nature"
            placeholder="请输入"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="年营业额:" prop="AnnualTurnover">
          <el-input
            v-model="customerSingle.AnnualTurnover"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="年广告预算:" prop="AnnualAdBudget">
          <el-input
            v-model="customerSingle.AnnualAdBudget"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="各个平台预算:" prop="PlatformBudget">
          <el-input
            class="textarea-120"
            type="textarea"
            style="width: 202px; min-height: 120px"
            v-model="customerSingle.PlatformBudget"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司架构:" prop="Structure">
          <el-input
            class="textarea-120"
            type="textarea"
            style="width: 202px; min-height: 120px"
            v-model="customerSingle.Structure"
            placeholder="客户公司组织架构，费用在哪些部门"
          ></el-input>
        </el-form-item>
        <el-form-item label="主要经营产品:" prop="MainBusiness">
          <el-input
            class="textarea-120"
            type="textarea"
            style="width: 202px; min-height: 120px"
            v-model="customerSingle.MainBusiness"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="产品售价/特征:" prop="ProductProperties">
          <el-input
            class="textarea-120"
            type="textarea"
            style="width: 202px; min-height: 120px"
            v-model="customerSingle.ProductProperties"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="重点营销月份:" prop="MarketingNodes">
          <el-select
            v-model="customerSingle.MarketingNodes"
            multiple
            placeholder="请选择"
            style="width: 202px"
          >
            <el-option label="1月" value="1月"></el-option>
            <el-option label="2月" value="2月"></el-option>
            <el-option label="3月" value="3月"></el-option>
            <el-option label="4月" value="4月"></el-option>
            <el-option label="5月" value="5月"></el-option>
            <el-option label="6月" value="6月"></el-option>
            <el-option label="7月" value="7月"></el-option>
            <el-option label="8月" value="8月"></el-option>
            <el-option label="9月" value="9月"></el-option>
            <el-option label="10月" value="10月"></el-option>
            <el-option label="11月" value="11月"></el-option>
            <el-option label="12月" value="12月"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周年庆/老板生日:">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="customerSingle.Anniversary"
            style="width: 202px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="关键人1:" prop="Contact1">
          <el-input
            v-model="customerSingle.Contact1"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="职级:" prop="Grade1">
          <el-input
            v-model="customerSingle.Grade1"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="关键人2:" prop="Contact2">
          <el-input
            v-model="customerSingle.Contact2"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="职级:" prop="Grade2">
          <el-input
            v-model="customerSingle.Grade2"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="关键人3:" prop="Contact3">
          <el-input
            v-model="customerSingle.Contact3"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="职级:" prop="Grade3">
          <el-input
            v-model="customerSingle.Grade3"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="主要营销诉求:" prop="MarketingAppeal">
          <el-input
            class="textarea-120"
            type="textarea"
            style="width: 575px; min-height: 120px"
            v-model="customerSingle.MarketingAppeal"
            placeholder="请用文字详细描述客户主要营销诉求"
          ></el-input>
        </el-form-item>
        <el-form-item label="当前投放情况:" prop="CurrentPutDesc">
          <el-input
            class="textarea-120"
            type="textarea"
            style="width: 575px; min-height: 120px"
            v-model="customerSingle.CurrentPutDesc"
            placeholder="请用文字描述，可填写账户名称、投放渠道、预算分布、投放地域、转化形式、投放成本及目前投放情况等，不少于100字"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="24">
            <h6 class="cus-title">客户公司竞对信息：</h6>
          </el-col>
        </el-row>
        <el-form-item label="主要竞争对手:" prop="Competitor">
          <el-input
            v-model="customerSingle.Competitor"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="竞对投放情况:" prop="PutDesc">
          <el-input
            v-model="customerSingle.PutDesc"
            placeholder="请输入竞对预算、产品受众、竞品优劣势等"
          ></el-input>
        </el-form-item>
        <el-form-item label="主要竞争对手2:" prop="Competitor2">
          <el-input
            v-model="customerSingle.Competitor2"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="竞对投放情况2:" prop="PutDesc2">
          <el-input
            v-model="customerSingle.PutDesc2"
            placeholder="请输入竞对预算、产品受众、竞品优劣势等"
          ></el-input>
        </el-form-item>
        <el-form-item label="主要竞争对手3:" prop="Competitor3">
          <el-input
            v-model="customerSingle.Competitor3"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="竞对投放情况3:" prop="PutDesc3">
          <el-input
            v-model="customerSingle.PutDesc3"
            placeholder="请输入竞对预算、产品受众、竞品优劣势等"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="24">
            <h6 class="cus-title">
              客户公司后链路数据：<span class="word-small"
                >后链路数据要求真实的填写，如实在无法填报，请备注清楚原因</span
              >
            </h6>
          </el-col>
        </el-row>
        <el-form-item label="当月线索量:" prop="CurrentClueQuantity">
          <el-input
            v-model="customerSingle.CurrentClueQuantity"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="当月线索成本:" prop="CurrentClueCost">
          <el-input
            v-model="customerSingle.CurrentClueCost"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="当月线索有效率:" prop="CurrentClueEfficient">
          <el-input
            v-model="customerSingle.CurrentClueEfficient"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="行业成本:" prop="IndustryCost">
          <el-input
            v-model="customerSingle.IndustryCost"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="备注:" prop="Remark">
          <el-input
            v-model="customerSingle.Remark"
            placeholder="后链路数据要求真实的填写，如实在无法填报，请备注清楚原因"
            @blur="handleChangeRemark"
          ></el-input>
        </el-form-item> -->
        <el-row>
          <el-col :span="24">
            <h6 class="cus-title">客户公司品牌跟进：</h6>
          </el-col>
        </el-row>
        <el-form-item label="适配品牌产品:" prop="BrandProducts">
          <el-input
            v-model="customerSingle.BrandProducts"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="预计到款时间:" prop="ExpectedPayTime">
          <!-- <el-input
            v-model="customerSingle.ExpectedPayTime"
            placeholder="请填写"
          ></el-input> -->
          <el-date-picker
            type="date"
            placeholder="选择预计到款时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="customerSingle.ExpectedPayTime"
            style="width: 202px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="预计到款金额:" prop="ExpectedPayAmount">
          <el-input
            v-model="customerSingle.ExpectedPayAmount"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="跟进卡点:" prop="FollowQuestion">
          <el-input
            v-model="customerSingle.FollowQuestion"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="EventCancel">取 消</el-button>
      <el-button type="primary" @click="EventSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {} from "@/until/ZeusApiSDK/Logic/CustomerProfile";
export default {
  name: "custDialog",
  data() {
    return {
      value: [],
      options: [],
      Scale: [
        "少于50人",
        "50-99人",
        " 100-199人",
        "200-299人",
        " 300-399人",
        "400-499人",
        "500-599人",
        " 600-699人",
        "700-799人",
        "800-899人",
        "900-999人",
        "1000-1999人",
        "2000-2999人",
        "3000-3999人",
        "4000-4999人",
        "5000-5999人",
        "6000-6999人",
        "7000-7999人",
        "8000-8999人",
        "9000-9999人",
        "10000人以上",
      ],
      // Gradelist: ["A类", "B类", "C类", "D类"],
      rules: {
        Nature: [
          { required: true, message: "请输入公司性质", trigger: "blur" },
        ],
        Scale: [{ required: true, message: "请输入公司规模", trigger: "blur" }],
        // Industry: [
        //   { required: true, message: "请输入公司行业类目", trigger: "blur" },
        // ],
        IsIPO: [
          { required: true, message: "请选择公司是否上市", trigger: "change" },
        ],
        Structure: [
          { required: true, message: "请输入公司架构", trigger: "blur" },
        ],
        MainBusiness: [
          { required: true, message: "请输入主要经营产品", trigger: "blur" },
        ],
        ProductProperties: [
          { required: true, message: "请输入产品售价/特征", trigger: "blur" },
        ],
        AnnualTurnover: [
          { required: true, message: "请选择年营业额", trigger: "blur" },
        ],
        AnnualAdBudget: [
          { required: true, message: "请输入年广告预算", trigger: "blur" },
        ],
        PlatformBudget: [
          { required: true, message: "请输入各个平台预算", trigger: "blur" },
        ],
        MarketingNodes: [
          { required: true, message: "请输入重点营销月份", trigger: "blur" },
        ],
        MarketingAppeal: [
          { required: true, message: "请输入主要营销诉求", trigger: "blur" },
        ],
        Anniversary: [
          {
            required: false,
            message: "请选择周年庆/老板生日",
            trigger: "blur",
          },
        ],
        Contact1: [
          { required: true, message: "请输入关键人1名称", trigger: "blur" },
        ],
        Grade1: [
          { required: true, message: "请输入关键人1职级", trigger: "blur" },
        ],
        Contact2: [
          { required: true, message: "请输入关键人2名称", trigger: "blur" },
        ],
        Grade2: [
          { required: true, message: "请输入关键人2职级", trigger: "blur" },
        ],
        Contact3: [
          { required: false, message: "请输入关键人3名称", trigger: "blur" },
        ],
        Grade3: [
          { required: false, message: "请输入关键人3职级", trigger: "blur" },
        ],
        CurrentPutDesc: [
          { required: true, message: "请输入当前投放情况", trigger: "blur" },
        ],
        Competitor: [
          { required: true, message: "请输入竞争对手", trigger: "blur" },
        ],
        PutDesc: [
          {
            required: true,
            message: "请输入竞争对手投放情况",
            trigger: "blur",
          },
        ],
        Competitor2: [
          { required: true, message: "请输入竞争对手2", trigger: "blur" },
        ],
        PutDesc2: [
          {
            required: true,
            message: "请输入竞争对手2投放情况",
            trigger: "blur",
          },
        ],
        Competitor3: [
          { required: false, message: "请输入竞争对手3", trigger: "blur" },
        ],
        PutDesc3: [
          {
            required: false,
            message: "请输入竞争对手3投放情况",
            trigger: "blur",
          },
        ],
        CurrentClueQuantity: [
          {
            required: true,
            message: "请输入当月线索量",
            trigger: "blur",
          },
        ],
        CurrentClueCost: [
          {
            required: true,
            message: "请输入当月线索成本",
            trigger: "blur",
          },
        ],
        CurrentClueEfficient: [
          {
            required: true,
            message: "请输入当月线索有效率",
            trigger: "blur",
          },
        ],
        IndustryCost: [
          {
            required: true,
            message: "请输入行业成本",
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: {
    customerSingle: {
      type: Object,
    },
    visible: {
      type: Boolean,
    },
    dialogTitle: {
      type: String,
    },
    industry: {
      type: Array,
    },
    Info: {
      type: Object,
    },
  },
  created() {},
  methods: {
    handleClose() {
      this.$emit("close");
    },
    EventCancel() {
      this.$emit("close");
    },
    EventSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit("submit");
        } else {
          this.$message.error("请检查表单填写完毕后再试~");
          return false;
        }
      });
    },
    // handleChangeRemark() {
    //   let _flag = true;
    //   _flag = this.customerSingle.Remark !== "" ? false : true;
    //   this.rules.CurrentClueQuantity[0].required = _flag;
    //   this.rules.CurrentClueCost[0].required = _flag;
    //   this.rules.CurrentClueEfficient[0].required = _flag;
    //   this.rules.IndustryCost[0].required = _flag;
    // }
  },
};
</script>
<style lang="less">
.cus-title {
  font-size: 15px;
  line-height: 60px;
  margin: 0;
  .word-small {
    font-size: 12px;
    color: rgb(255, 169, 98);
  }
}
.el-form-item {
  .el-form-item__content {
    .el-textarea {
      textarea {
        font-family: Arial;
      }
    }
  }
  .textarea-120 {
    textarea {
      min-height: 120px !important;
      box-sizing: border-box;
    }
  }
  .textarea-40 {
    textarea {
      min-height: 60px !important;
      box-sizing: border-box;
    }
  }
}
</style>
